import React from 'react'
import { connect } from 'react-redux'

import Confirm from 'views/confirm/confirm'
import confirmTypes from 'helpers/enums/confirmTypes'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import generalActions from 'redux/actions/generalActions'
import { localize } from 'helpers/translator'

const CONFIRM_TYPE = confirmTypes.MY_LIBRARY_FIRST_LESSON_FILE_PICKED_ERROR

const MyLibraryFirstLessonFilePickedError = props => (
	<Confirm
		btTwo={localize('global_ok')}
		alertMessage={props.message}
		actionButtonType={0}
		actionTwo={() => props.actions.closeConfirm(CONFIRM_TYPE)}
		closeAction={() => props.actions.closeConfirm(CONFIRM_TYPE)}
	/>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		closeConfirm: generalActions.closeConfirm,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(MyLibraryFirstLessonFilePickedError)
